import React from "react";
import { Container } from "react-bootstrap";
import Logo from "../../assets/checkinimg/img.png";
import "./CheckInLanding.css";

const Footer = () => {
    return (
        <footer className="footer-section">
            <Container>
                <div className="footer-wrappers">

                    <div className="footer-logo">
                        <img src={Logo} alt="Logo" />
                    </div>

                    <p className="footer-copy">
                        © {new Date().getFullYear()} Keep in Touch. All rights reserved.
                    </p>

                    <nav className="footer-nav">
                        <a href="#">Privacy</a>
                        <a href="#">Terms</a>
                        <a href="#">Contact</a>
                    </nav>

                </div>
            </Container>
        </footer>
    );
};

export default Footer;